import CommonState from '@/class/cargo/model/parameters/CommonState'
import RadioStatusConstants, { NO, YES } from '@/class/cargo/model/parameters/RadioStatusConstants'

// 目的地配送方式
export const TRUCK = new CommonState('0', '卡车', 'Truck')
export const EXPRESS = new CommonState('1', '快递', 'Express')
export const AMAZON_PICKUP = new CommonState('2', '亚马逊自提', 'Amazon Pickup')
export const DESTINATION_DISTRIBUTION_TYPES = [TRUCK, EXPRESS, AMAZON_PICKUP]

// 库龄计算方式
export const MON_ACROSS = new CommonState(1, '星期一跨周', 'Monday Across Week')
export const TUES_ACROSS = new CommonState(2, '星期二跨周', 'Tuesday Across Week')
export const WED_ACROSS = new CommonState(3, '星期三跨周', 'Wednesday Across Week')
export const THUR_ACROSS = new CommonState(4, '星期四跨周', 'Thursday Across Week')
export const FRI_ACROSS = new CommonState(5, '星期五跨周', 'Friday Across Week')
export const SAT_ACROSS = new CommonState(6, '星期六跨周', 'Saturday Across Week')
export const SUN_ACROSS = new CommonState(7, '星期日跨周', 'Sunday Across Week')
export const WAREHOUSE_AGE_CALCULATION_RULES_TYPES = [MON_ACROSS, TUES_ACROSS, WED_ACROSS, THUR_ACROSS, FRI_ACROSS, SAT_ACROSS, SUN_ACROSS]

// 仓库操作方式
export const WAREHOUSE_OP_CHECKLIST = 'CHECKLIST' // 核单
export const WAREHOUSE_OP_ROLLBACK_CHECKLIST = 'ROLLBACK_CHECKLIST' // 撤销核单
export const WAREHOUSE_OP_RETURNGOODS = 'RETURNGOODS' // 退件
export const WAREHOUSE_OP_REGISTRATIONSLIP = 'REGISTRATIONSLIP' // 登记面单
export const WAREHOUSE_OP_PACKING = 'PACKING' // 装箱
export const WAREHOUSE_OP_EXWAREHOUSE = 'EXWAREHOUSE' // 出库
export const WAREHOUSE_OP_ROLLBACK_EXWAREHOUSE = 'ROLLBACK_EXWAREHOUSE' // 撤销出库
export const WAREHOUSE_OP_INWAREHOUSE = 'INWAREHOUSE' // 国外仓入库

//
export const WAREHOUSE_OP_STORED = 'STORED' // 完全入库/取消完全入库

// 整拼类型
export const CONTAINER_LOAD_TYPE_FCL = new CommonState('FCL', '整箱', 'FCL')
export const CONTAINER_LOAD_TYPE_LCL = new CommonState('LCL', '拼箱', 'LCL')
export const CONTAINER_LOAD_TYPE_BB = new CommonState('BB', '委托拼箱', 'Consignment LCL')
export const CONTAINER_LOAD_TYPES = [CONTAINER_LOAD_TYPE_FCL, CONTAINER_LOAD_TYPE_LCL]

// FBA整拼类型
export const FBA_CONTAINER_LOAD_TYPE_FCL = new CommonState('FCL', '整箱', 'FCL')
export const FBA_CONTAINER_LOAD_TYPE_LCL = new CommonState('LCL', '拼箱', 'LCL')
export const FBA_CONTAINER_LOAD_TYPES = [FBA_CONTAINER_LOAD_TYPE_FCL, FBA_CONTAINER_LOAD_TYPE_LCL]

// 运输方式
export const SHIPPING_TYPE_SE = new CommonState('SE', '海运', 'SE')
export const SHIPPING_TYPE_AE = new CommonState('AE', '空运', 'AE')
export const SHIPPING_TYPE_RE = new CommonState('RE', '铁路', 'RE')
export const SHIPPING_TYPES = [SHIPPING_TYPE_SE, SHIPPING_TYPE_AE, SHIPPING_TYPE_RE]

// 目的地配送方式
export const CUSTOMER_PICKUP = new CommonState(3, '客户自提', 'Customer Pickup')
export const ORDER_DESTINATION_DISTRIBUTION_TYPES = [TRUCK, EXPRESS, CUSTOMER_PICKUP]

// 渠道启用状态
export const CHANNEL_ENABLE = new CommonState(true, '启用', 'Enable')
export const CHANNEL_DISABLED = new CommonState(false, '禁用', 'Disabled')
export const CHANNEL_ACTIVE_STATE = [CHANNEL_ENABLE, CHANNEL_DISABLED]

// 出库方式
export const DELIVERY_MODE_PALLET = new CommonState(1, '托盘', 'Pallet')
export const DELIVERY_MODE_CONTAINER = new CommonState(2, '货箱', 'Container')
export const DELIVERY_MODES = [DELIVERY_MODE_PALLET, DELIVERY_MODE_CONTAINER]

// 出库状态
export const DELIVERY_STATUS_OUT = new CommonState(1, '已出库', 'Issued')
export const DELIVERY_STATUS_ROLL_BACK = new CommonState(2, '已撤销', 'rescinded')
export const DELIVERY_STATUS = [DELIVERY_STATUS_OUT, DELIVERY_STATUS_ROLL_BACK]

// 国外仓状态
export const OVERSEA_WAREHOUSE_STATUS_NO_WAREHOUSING = new CommonState(0, '待入库', 'No warehousing')
export const OVERSEA_WAREHOUSE_STATUS_WAREHOUSING = new CommonState(1, '已入库', 'Warehousing')
export const OVERSEA_WAREHOUSE_STATUS_PARTIAL_DELIVERY = new CommonState(2, '部分出库', 'Partial delivery')
export const OVERSEA_WAREHOUSE_STATUS_ISSUED = new CommonState(3, '已出库', 'Issued')
export const OVERSEA_WAREHOUSE_STATUS = [OVERSEA_WAREHOUSE_STATUS_NO_WAREHOUSING, OVERSEA_WAREHOUSE_STATUS_WAREHOUSING, OVERSEA_WAREHOUSE_STATUS_PARTIAL_DELIVERY, OVERSEA_WAREHOUSE_STATUS_ISSUED]

// 快递公司
export const EXPRESS_COMPANY_UPS = new CommonState('UPS', 'UPS', 'UPS')
export const EXPRESS_COMPANY_DHL = new CommonState('DHL', 'DHL', 'DHL')
export const EXPRESS_COMPANY_FEDEX = new CommonState('FedEx', 'FedEx', 'FedEx')
export const EXPRESS_COMPANY_TNT = new CommonState('TNT', 'TNT', 'TNT')
export const EXPRESS_COMPANY_EMS = new CommonState('EMS', 'EMS', 'EMS')
export const EXPRESS_COMPANY_ROYAL_MAIL = new CommonState('Royal Mail', 'Royal Mail', 'Royal Mail')
export const EXPRESS_COMPANY_AAE = new CommonState('AAE', 'AAE', 'AAE')
export const EXPRESS_COMPANY_DTDC = new CommonState('DTDC', 'DTDC', 'DTDC')
export const EXPRESS_COMPANYS = [EXPRESS_COMPANY_UPS, EXPRESS_COMPANY_DHL, EXPRESS_COMPANY_FEDEX, EXPRESS_COMPANY_TNT, EXPRESS_COMPANY_EMS, EXPRESS_COMPANY_ROYAL_MAIL, EXPRESS_COMPANY_AAE, EXPRESS_COMPANY_DTDC]

// FBA预审状态
export const VERIFY_STATE_PENDING = new CommonState(0, '待审核', 'Pending')
export const VERIFY_STATE_APPROVED = new CommonState(1, '已审核', 'Approved')
export const VERIFY_STATE_REFUSE = new CommonState(2, '已拒绝', 'refuse')
export const VERIFY_STATE_REVIEWED = new CommonState(5, '复核通过', 'Reviewed and passed')
export const VERIFY_STATE_REVIEW_REFUSE = new CommonState(6, '复核拒绝', 'Review rejection')
export const VERIFYING_REVOKE = new CommonState(7, '已作废', 'VerifyRevoked')
export const VERIFY_STATES_NEW = [VERIFY_STATE_PENDING, VERIFY_STATE_APPROVED, VERIFY_STATE_REFUSE]
export const VERIFY_STATES = [VERIFY_STATE_PENDING, VERIFY_STATE_APPROVED, VERIFY_STATE_REFUSE, VERIFY_STATE_REVIEWED, VERIFY_STATE_REVIEW_REFUSE, VERIFYING_REVOKE]

// FBA预审提交状态
export const SUBMIT_STATE_PENDING = new CommonState(1, '暂不提交', 'Do not submit temporarily')
export const SUBMIT_STATE_SUBMITTED = new CommonState(2, '已提交', 'Submitted')
export const SUBMIT_STATES = [SUBMIT_STATE_PENDING, SUBMIT_STATE_SUBMITTED]

// 计费方式
export const CHARGING_METHOD_CBM = new RadioStatusConstants('1', 'CBM', 'CBM')
export const CHARGING_METHOD_KG = new RadioStatusConstants('0', 'KG', 'KG')
export const CHARGING_METHODS = [CHARGING_METHOD_CBM, CHARGING_METHOD_KG]

// 结算重量进位规则
export const ROUNDING_RULES_CEIL = new CommonState(0, '向上取整', 'Round up')
export const ROUNDING_RULES_FLOOR = new CommonState(1, '向下取整', 'Round down')
export const ROUNDING_RULES_ROUND = new CommonState(2, '四舍五入', 'Round')
export const SETTLEMENT_WEIGHT_ROUNDING_RULES = [ROUNDING_RULES_CEIL, ROUNDING_RULES_FLOOR, ROUNDING_RULES_ROUND]

// 多箱计算规则
export const COMPARE_BEFORE_ACCUMULATE = new CommonState(0, '先比较再累加', 'Compare before accumulate')
export const COMPARE_AFTER_ACCUMULATE = new CommonState(1, '先累加再比较', 'Compare after accumulate')
export const MULTIPLE_BOXES_CALCULATION_RULES = [COMPARE_BEFORE_ACCUMULATE, COMPARE_AFTER_ACCUMULATE]

// FBA报价状态
export const QUOTATION_STATE_NOT_EFFECTIVE = new CommonState(1, '未生效', 'Not effective')
export const QUOTATION_STATE_EFFECTIVE = new CommonState(2, '已生效', 'Effective')
export const QUOTATION_STATE_EXPIRED = new CommonState(3, '已过期', 'Expired')
export const QUOTATION_STATES = [QUOTATION_STATE_NOT_EFFECTIVE, QUOTATION_STATE_EFFECTIVE, QUOTATION_STATE_EXPIRED]

// 计算方式
export const CALC_UNIT_PRICE = new CommonState(0, '单价', 'Unit Price')
export const CALC_FIRST_WEIGHT = new CommonState(1, '首重', 'First weight')
export const CALC_TOTAL_AMOUNT = new CommonState(2, '总金额', 'Total amount')
export const CALC_WEIGHT_CONTINUATION = new CommonState(3, '续重', 'Weight continuation')
export const CALC_METHOD = [CALC_UNIT_PRICE, CALC_FIRST_WEIGHT, CALC_TOTAL_AMOUNT, CALC_WEIGHT_CONTINUATION]

// 报价对象
export const QUOTATION_OBJECT_COST_PRICE = new CommonState(0, '成本价', 'Cost Price')
export const QUOTATION_OBJECT_PEER_PRICE = new CommonState(1, '同行价', 'Peer Price')
export const QUOTATION_OBJECT_DIRECT_PRICE = new CommonState(2, '直客价', 'Direct Price')
export const QUOTATION_OBJECT_MARKET_PRICE = new CommonState(3, '市场价', 'Market Price')
export const QUOTATION_OBJECTS = [QUOTATION_OBJECT_COST_PRICE, QUOTATION_OBJECT_PEER_PRICE, QUOTATION_OBJECT_DIRECT_PRICE, QUOTATION_OBJECT_MARKET_PRICE]

// 附加费类型
export const SURCHARGE_TYPE_BILLING_BY_TICKET = new CommonState(0, '按票计费', 'Billing by ticket')
export const SURCHARGE_TYPE_BILLING_BY_BOX = new CommonState(1, '按箱计费', 'Billing by box')
export const SURCHARGE_TYPE_FUEL_SURCHARGE = new CommonState(2, '燃油附加费', 'Fuel surcharge')
export const SURCHARGE_TYPE_REMOTE_SURCHARGE = new CommonState(3, '偏远附加费', 'Remote surcharge')
export const SURCHARGE_TYPE_SURCHARGE_FOR_GOODS_TYPE = new CommonState(4, '货物类型附加费', 'Surcharge for goods type')
export const SURCHARGE_TYPE_TAXATION = new CommonState(5, '税费', 'taxation')
export const SURCHARGE_TYPES = [SURCHARGE_TYPE_BILLING_BY_TICKET, SURCHARGE_TYPE_BILLING_BY_BOX, SURCHARGE_TYPE_FUEL_SURCHARGE, SURCHARGE_TYPE_REMOTE_SURCHARGE, SURCHARGE_TYPE_SURCHARGE_FOR_GOODS_TYPE, SURCHARGE_TYPE_TAXATION]

// 比较值类型
export const COMPARISON_TYPES_TOTAL_OUTER_CASE = new CommonState('ZWX', '总外箱(CTN)', 'Total outer case (CTN)')
export const COMPARISON_TYPES_TOTAL_WEIGHT = new CommonState('ZZL', '总重量(KG)', 'Total weight (KG)')
export const COMPARISON_TYPES_TOTAL_VOLUME = new CommonState('ZTJ', '总体积(CBM)', 'Total volume (CBM)')
export const COMPARISON_TYPES_SETTLEMENT_WEIGHT = new CommonState('JFZL', '计费重量(KG)', 'Charge weight (KG)')
export const COMPARISON_TYPES_VOLUME_WEIGHT = new CommonState('CJ', '材积(KG)', 'Volume Weight (KG)')
export const COMPARISON_TYPES = [COMPARISON_TYPES_TOTAL_OUTER_CASE, COMPARISON_TYPES_TOTAL_WEIGHT, COMPARISON_TYPES_TOTAL_VOLUME, COMPARISON_TYPES_SETTLEMENT_WEIGHT, COMPARISON_TYPES_VOLUME_WEIGHT]

// 比较值规则
export const COMPARISON_RULE_LESS_THAN = new CommonState(1, '小于', 'less than')
export const COMPARISON_RULE_LESS_THAN_EQUAL = new CommonState(2, '小于等于', 'Less than or equal to')
export const COMPARISON_RULE_GREATER_THAN = new CommonState(3, '大于', 'greater than')
export const COMPARISON_RULE_GREATER_THAN_EQUAL = new CommonState(4, '大于等于', 'Greater than or equal to')
export const COMPARISON_RULE_EQUAL = new CommonState(5, '等于', 'be equal to')
export const COMPARISON_RULE_NOT_EQUAL = new CommonState(6, '不等于', 'Not equal to')
export const COMPARISON_RULES = [COMPARISON_RULE_LESS_THAN, COMPARISON_RULE_LESS_THAN_EQUAL, COMPARISON_RULE_GREATER_THAN, COMPARISON_RULE_GREATER_THAN_EQUAL, COMPARISON_RULE_EQUAL, COMPARISON_RULE_NOT_EQUAL]

// 且、或
export const AND_OR_AND = new CommonState(1, '且', 'AND')
export const AND_OR_OR = new CommonState(2, '或', 'OR')
export const AND_OR = [AND_OR_AND, AND_OR_OR]

// 加减乘除取小
export const CALC_MODE_PLUS = new CommonState(1, '加', 'plus')
export const CALC_MODE_MINUS = new CommonState(2, '减', 'minus')
export const CALC_MODE_MULTIPLY = new CommonState(3, '乘', 'multiply')
export const CALC_MODE_DIVIDE = new CommonState(4, '除', 'divide')
export const CALC_MODE_TAKE_SMALL = new CommonState(5, '取小', 'take small')
export const CALC_MODE_TAKE_BIG = new CommonState(6, '取大', 'take big')
export const CALC_MODES = [CALC_MODE_PLUS, CALC_MODE_MINUS, CALC_MODE_MULTIPLY, CALC_MODE_DIVIDE, CALC_MODE_TAKE_SMALL, CALC_MODE_TAKE_BIG]
